<template>
  <div class="pages">
    <navTop></navTop>
    <div class="box">
      <!-- 顶部图片 -->
      <div class="box-img"><img :src="details.servePic" /></div>
      <!-- 内容 -->
      <div class="box-main">
        <div class="box-main-title">{{ details.serveTitle }}</div>
        <img src="../../assets/orderDetails-main-img.png" class="box-main-img" />
        <ul>
          <li class="li1">
            <span>Price</span>
            <span>${{ details.price }}</span>
          </li>
          <li class="li1">
            <span>Full name</span>
            <span>{{ details.name }}</span>
          </li>
          <li class="li1">
            <span>Cell-phone number</span>
            <span>{{ details.phone }}</span>
          </li>
          <li class="li1">
            <span>Corporate name</span>
            <span>{{ details.company }}</span>
          </li>
          <li class="li1">
            <span>Company address</span>
            <span>{{ details.address }}</span>
          </li>
          <li class="li1">
            <span>Service city</span>
            <span>{{ details.city }}</span>
          </li>
          <li class="li1">
            <span>Service date</span>
            <span>{{ details.workDate }}</span>
          </li>
          <li class="li1">
            <span>Name of inspector</span>
            <span v-if="details.docName">{{ details.docName}} </span>
          </li>
          <li class="li1">
            <span>Type</span>
            <span v-if="details.serveType == 0">Supervision of loading</span>
            <span v-if="details.serveType == 1">Measure oil</span>
            <span v-if="details.serveType == 2">Come on.</span>
            <span v-if="details.serveType == 3">Draft</span>
            <span v-if="details.serveType == 4">Insurance</span>
          </li>
          <li class="li1">
            <span>Order status</span>
            <span v-if="details.isPause == 0 && details.status == 0">Pending payment</span>
            <span v-if="details.isPause == 0 && details.status == 1">
							To be received by the inspector
						</span>
            <span v-if="details.isPause == 0 && details.status == 2">Order cancelled</span>
            <span v-if="details.isPause == 0 && details.status == 3">Inspector to go</span>
            <span v-if="details.isPause == 0 && details.status == 4">The surveyor has set out</span>
            <span v-if="details.isPause == 0 && details.status == 5">
							The inspector has arrived
						</span>
            <span v-if="details.isPause == 0 && details.status == 6">The inspector is working</span>
            <span v-if="details.isPause == 0 && details.status == 7">Uploaded certificate</span>
            <span v-if="details.isPause == 0 && details.status == 8">Inspector completed</span>
            <span v-if="details.isPause == 0 && details.status == 9">To be evaluated</span>
            <span v-if="details.isPause == 0 && details.status == 10">Evaluated</span>
            <span v-if="details.isPause == 0 && details.status == 11">Inspector rejected</span>
            <span v-if="details.isPause == 0 && details.status == 12">Refunded</span>
            <span v-if="details.isPause == 1">Refund under review</span>
            <span v-if="details.isPause == 2">Additional charges to be paid</span>
            <span v-if="details.isPause == 3">Urgent report to be reviewed</span>
            <span v-if="details.isPause == 4">User insurance to be paid</span>
            <span v-if="details.isPause == 5">After sales audit in progress</span>
          </li>
          <li class="li1">
            <span>Order No</span>
            <span>{{ details.orderNum }}</span>
          </li>
          <li class="li1">
            <span>Order time</span>
            <span>{{ details.createDate }}</span>
          </li>
          <!-- 待接单 -->
          <li class="li1" v-if="details.isPause == 0 && details.status == 1">
            <span>Payment time</span>
            <span>{{ details.payTime }}</span>
          </li>
          <!-- 已取消 -->
          <li class="li1" v-if="details.isPause == 0 && details.status == 2">
            <span>Payment time</span>
            <span>{{ details.payTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 2">
            <span>Cancel time</span>
            <span>{{ details.cancelTime }}</span>
          </li>
          <!-- 待出发 -->
          <li class="li1" v-if="details.isPause == 0 && details.status == 3">
            <span>Payment time</span>
            <span>{{ details.payTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 3">
            <span>Order receiving time</span>
            <span>{{ details.receivingTime }}</span>
          </li>
          <!-- 已出发 -->
          <li class="li1" v-if="details.isPause == 0 && details.status == 4">
            <span>Payment time</span>
            <span>{{ details.payTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 4">
            <span>Order receiving time</span>
            <span>{{ details.receivingTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 4">
            <span>Departure time</span>
            <span>{{ details.departTime }}</span>
          </li>
          <!-- 已到达 -->
          <li class="li1" v-if="details.isPause == 0 && details.status == 5">
            <span>Payment time</span>
            <span>{{ details.payTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 5">
            <span>Order receiving time</span>
            <span>{{ details.receivingTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 5">
            <span>Departure time</span>
            <span>{{ details.departTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 5">
            <span>Arrival time</span>
            <span>{{ details.arriveTime }}</span>
          </li>
          <!-- 开始工作 -->
          <li class="li1" v-if="details.isPause == 0 && details.status == 6">
            <span>Payment time</span>
            <span>{{ details.payTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 6">
            <span>Order receiving time</span>
            <span>{{ details.receivingTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 6">
            <span>Departure time</span>
            <span>{{ details.departTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 6">
            <span>Arrival time</span>
            <span>{{ details.arriveTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 6">
            <span>Start working time</span>
            <span>{{ details.startWorkTime }}</span>
          </li>
          <!-- 已完成 -->
          <li class="li1" v-if="details.isPause == 0 && details.status == 8">
            <span>Payment time</span>
            <span>{{ details.payTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 8">
            <span>Order receiving time</span>
            <span>{{ details.receivingTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 8">
            <span>Departure time</span>
            <span>{{ details.departTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 8">
            <span>Arrival time</span>
            <span>{{ details.arriveTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 8">
            <span>Start working time</span>
            <span>{{ details.startWorkTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 8">
            <span>Completion time</span>
            <span>{{ details.accomplishTime }}</span>
          </li>
          <!-- 已验收 -->
          <li class="li1" v-if="details.isPause == 0 && details.status == 9">
            <span>Payment time</span>
            <span>{{ details.payTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 9">
            <span>Order receiving time</span>
            <span>{{ details.receivingTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 9">
            <span>Departure time</span>
            <span>{{ details.departTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 9">
            <span>Arrival time</span>
            <span>{{ details.arriveTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 9">
            <span>Start working time</span>
            <span>{{ details.startWorkTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 9">
            <span>Completion time</span>
            <span>{{ details.accomplishTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 9">
            <span>Acceptance time</span>
            <span>{{ details.checkTime }}</span>
          </li>
          <!-- 待评价 -->
          <li class="li1" v-if="details.isPause == 0 && details.status == 10">
            <span>Payment time</span>
            <span>{{ details.payTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 10">
            <span>Order receiving time</span>
            <span>{{ details.receivingTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 10">
            <span>Departure time</span>
            <span>{{ details.departTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 10">
            <span>Arrival time</span>
            <span>{{ details.arriveTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 10">
            <span>Start working time</span>
            <span>{{ details.startWorkTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 10">
            <span>Completion time</span>
            <span>{{ details.accomplishTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 10">
            <span>Acceptance time</span>
            <span>{{ details.checkTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 10">
            <span>Evaluation time</span>
            <span>{{ details.appraiseTime }}</span>
          </li>
          <!-- 退款成功时间 -->
          <li class="li1" v-if="details.isPause == 0 && details.status == 12">
            <span>Time to apply for refund</span>
            <span>{{ details.refundTime }}</span>
          </li>
          <li class="li1" v-if="details.isPause == 0 && details.status == 12">
            <span>Refund success time</span>
            <span>{{ details.agreeRefundTime }}</span>
          </li>
          <!-- 申请退款 -->
          <li class="li1" v-if="details.isPause == 1">
            <span>Time to apply for refund</span>
            <span>{{ details.refundTime }}</span>
          </li>
          <!--  -->
          <li class="li1">
            <span v-if="details.isPause == 5">Reject time</span>
            <span>{{ details.refuseRefundTimeDoc }}</span>
          </li>
          <li class="li2">
            <span>Detailed information</span>
            <span>{{ details.detail }}</span>
          </li>
          <li class="li2">
            <span>Remarks</span>
            <span>{{ details.remarks }}</span>
          </li>
        </ul>
      </div>
    </div>
    <navFooter></navFooter>
  </div>
</template>

<script>
import navTop from '../../components/navTop.vue';
import navFooter from '../../components/navFooter.vue';
export default {
  name: 'orderDetails',
  components: {
    navTop,
    navFooter
  },
  data() {
    return {
      id: '',
      details: {}
    };
  },
  created() {
    if (!sessionStorage.getItem('uid')) {
      this.$router.push({ path: '/' });
    } else {
      this.id = this.$route.query.id;
      this.getOrderdetail();
    }
  },
  methods: {
    getOrderdetail() {
      let data = {
        id: this.id
      };
      this.$api.orderdetail(data).then((res) => {
        console.log(res);
        if (res.result == 0) {
          this.details = res.data;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// 科技蓝色风格变量 - 使用 #1ba8e8 作为主色调
$blue-primary: #1ba8e8;
$blue-primary-rgba: rgba(27, 168, 232, 0.9);
$blue-secondary: #4ab9f0;
$blue-glow: rgba(27, 168, 232, 0.4);
$blue-light: rgba(27, 168, 232, 0.2);
$blue-dark: #0f2b3f;
$text-glow: 0 0 8px rgba(27, 168, 232, 0.5);

.pages {
  background: linear-gradient(135deg, #0f2b3f 0%, #1a3f5a 100%);
  position: relative;
  min-height: 10vh;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 30%, rgba(27, 168, 232, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }

  .box {
    margin: 30px auto 80px;
    max-width: 1400px;
    padding: 0 20px;
    position: relative;
    z-index: 2;
    box-sizing: border-box;

    // 顶部图片
    .box-img {
      img {
        width: 100%;
        height: 500px;
        display: block;
        border-radius: 20px;
        object-fit: cover;
        box-shadow: 0 0 40px $blue-glow;
        border: 1px solid $blue-primary-rgba;
      }
    }

    // 内容
    .box-main {
      width: 100%;
      margin-top: 40px;
      background: rgba(15, 43, 63, 0.8);
      backdrop-filter: blur(10px);
      border: 1px solid $blue-primary-rgba;
      border-radius: 35px;
      box-shadow: 0 0 40px $blue-glow;
      padding: 50px 60px 70px;
      box-sizing: border-box;

      .box-main-title {
        font-size: 36px;
        color: $blue-primary;
        line-height: 1.2em;
        text-align: center;
        text-shadow: $text-glow;
        margin-bottom: 20px;
      }

      .box-main-img {
        width: 100%;
        height: 2px;
        display: block;
        margin: 20px 0;
        background: linear-gradient(90deg, transparent, $blue-primary, transparent);
        border: none;
      }

      ul {
        padding: 30px 40px 0;
        box-sizing: border-box;

        .li1 {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 20px;
          padding: 10px 0;
          border-bottom: 1px dashed $blue-primary-rgba;

          span:nth-child(1) {
            font-size: 20px;
            color: #c0e4ff;
            line-height: 1.2em;
            font-weight: 500;
          }

          span:nth-child(2) {
            font-size: 20px;
            color: $blue-primary;
            line-height: 1.2em;
            font-weight: 500;
            text-align: right;
            max-width: 60%;
            word-break: break-word;
          }
        }

        .li2 {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
          margin-bottom: 30px;
          padding: 15px 0;
          border-bottom: 1px dashed $blue-primary-rgba;

          span:nth-child(1) {
            font-size: 20px;
            color: #c0e4ff;
            line-height: 1.2em;
            font-weight: 500;
            margin-bottom: 10px;
          }

          span:nth-child(2) {
            margin-top: 5px;
            font-size: 18px;
            color: $blue-primary;
            line-height: 1.5;
            word-break: break-word;
          }
        }

        .li2:last-child {
          margin-bottom: 0;
          border-bottom: none;
        }
      }
    }
  }
}

// 底部样式
::v-deep .footer {
  background: linear-gradient(90deg, #0f2b3f 0%, #1a3f5a 100%) !important;
  border-top: 2px solid $blue-primary !important;
  box-shadow: 0 -5px 25px $blue-glow !important;
  position: relative;
  z-index: 2;

  .footer-left {
    .logo {
      filter: drop-shadow(0 0 10px $blue-primary);
    }

    .text {
      color: #c0e4ff !important;

      span {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }
    }
  }

  .footer-right {
    .service {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .list {
        .li {
          color: #c0e4ff !important;

          &:hover {
            color: $blue-primary !important;
            text-shadow: $text-glow;
          }
        }
      }
    }

    .contact {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .item {
        color: #c0e4ff !important;

        img {
          filter: brightness(1.2) drop-shadow(0 0 5px $blue-primary);
        }
      }
    }

    .qrcode {
      border: 1px solid $blue-primary !important;
      box-shadow: 0 0 20px $blue-glow;
    }
  }

  // 其他网站区域
  .other-site {
    border-top: 1px solid rgba(27, 168, 232, 0.3) !important;
    margin-top: 30px !important;
    padding-top: 30px !important;

    .other-site-title {
      color: $blue-primary !important;
      font-size: 18px !important;
      font-weight: bold !important;
      margin-bottom: 15px !important;
      text-shadow: $text-glow;
      position: relative;
      display: inline-block;

      &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 50px;
        height: 2px;
        background: $blue-primary;
        box-shadow: 0 0 10px $blue-primary;
      }
    }

    .other-site-links {
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 15px !important;
      margin-bottom: 20px !important;

      .other-site-link-item {
        color: #c0e4ff !important;
        font-size: 14px !important;
        padding: 5px 15px !important;
        border: 1px solid rgba(27, 168, 232, 0.2) !important;
        border-radius: 20px !important;
        transition: all 0.3s ease !important;
        cursor: pointer !important;

        &:hover {
          border-color: $blue-primary !important;
          box-shadow: 0 0 15px $blue-glow !important;
          color: $blue-primary !important;
          transform: translateY(-2px);
        }
      }
    }

    .other-site-copyright {
      color: #c0e4ff !important;
      font-size: 13px !important;
      line-height: 1.8 !important;
      text-align: center !important;

      a {
        color: $blue-primary !important;
        text-decoration: none !important;
        transition: all 0.3s ease !important;

        &:hover {
          color: lighten($blue-primary, 20%) !important;
          text-shadow: $text-glow;
        }
      }

      .icp {
        color: #c0e4ff !important;
        margin: 0 5px;

        span {
          color: $blue-primary !important;
        }
      }

      .beian {
        color: #c0e4ff !important;
        margin: 0 5px;

        a {
          color: $blue-primary !important;
        }
      }

      .company {
        color: $blue-primary !important;
        font-weight: bold;
      }
    }
  }
}

// 响应式调整
@media screen and (max-width: 1200px) {
  .pages {
    .box {
      .box-img {
        img {
          height: 400px;
        }
      }

      .box-main {
        padding: 40px 30px 50px;

        .box-main-title {
          font-size: 28px;
        }

        ul {
          padding: 20px 20px 0;

          .li1 {
            span:nth-child(1), span:nth-child(2) {
              font-size: 18px;
            }
          }

          .li2 {
            span:nth-child(1) {
              font-size: 18px;
            }

            span:nth-child(2) {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .pages {
    .box {
      .box-img {
        img {
          height: 300px;
        }
      }

      .box-main {
        padding: 30px 20px 40px;

        .box-main-title {
          font-size: 24px;
        }

        ul {
          padding: 15px 10px 0;

          .li1 {
            flex-direction: column;
            align-items: flex-start;
            gap: 5px;

            span:nth-child(1), span:nth-child(2) {
              font-size: 16px;
              text-align: left;
              max-width: 100%;
            }
          }

          .li2 {
            span:nth-child(1) {
              font-size: 16px;
            }

            span:nth-child(2) {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>